var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dp-problem-problem" }, [
    _c("div", { staticClass: "problem-content" }, [
      _c("div", { staticClass: "b-readable-l" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "solv-problem" }, [
          _c("div", {
            staticClass: "solv-content",
            domProps: { innerHTML: _vm._s(_vm.problem.rendered_question) }
          })
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { domProps: { innerHTML: _vm._s(_vm.problem.problem_html) } }),
    _vm._v(" "),
    _c(
      "div",
      {
        class: ["dp-solv-details solv-details", { completed: _vm.isCompleted }]
      },
      [
        !_vm.isLocked
          ? [
              !_vm.problem.target_visualization
                ? _c(
                    "div",
                    {
                      staticClass: "solv-form clearfix",
                      attrs: { "data-block": "instant_answer_form" }
                    },
                    [
                      !_vm.isCompleted && _vm.isMultiSelectProblem
                        ? _c("p", { staticClass: "solv-one-or-more" }, [
                            _vm._v("\n          Select one or more\n        ")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isAuthenticated &&
                      !_vm.isCompleted &&
                      !_vm.hasMultipleChoices
                        ? _c("p", { staticClass: "solv-tries-left" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.problem.tries_left) +
                                " try left.\n        "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "solv-mcq-wrapper row" }, [
                        _c(
                          "form",
                          {
                            staticClass: "solv-form",
                            on: {
                              submit: function($event) {
                                $event.preventDefault()
                                return _vm.submitAnswer($event)
                              }
                            }
                          },
                          [
                            _vm.hasMultipleChoices
                              ? _vm._l(
                                  _vm.problem.rendered_mcq_choices,
                                  function(option, index) {
                                    return _c(
                                      "label",
                                      {
                                        key: index,
                                        class: [
                                          "solv-mcq-option",
                                          {
                                            disabled: _vm.isCompleted,
                                            correct: _vm.isCorrectMcqChoice(
                                              option.raw_choice,
                                              index
                                            ),
                                            active: _vm.isUserMcqChoice(
                                              option.raw_choice,
                                              index
                                            )
                                          }
                                        ]
                                      },
                                      [
                                        !_vm.isCompleted
                                          ? _c("input", {
                                              attrs: {
                                                type: "radio",
                                                name: "answer"
                                              },
                                              domProps: { value: index + 1 },
                                              on: {
                                                click: function($event) {
                                                  return _vm.selectAnswer(
                                                    option.raw_choice,
                                                    index
                                                  )
                                                }
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "solv-mcq-text",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              option.rendered_choice
                                            )
                                          }
                                        })
                                      ]
                                    )
                                  }
                                )
                              : [
                                  !_vm.isCompleted
                                    ? _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.singleAnswer,
                                            expression: "singleAnswer"
                                          }
                                        ],
                                        staticClass: "placeholder",
                                        attrs: {
                                          disabled: _vm.problem.tries_left < 1,
                                          type: "text",
                                          autocomplete: "off",
                                          placeholder: "Type your answer",
                                          tabindex: "1"
                                        },
                                        domProps: { value: _vm.singleAnswer },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.singleAnswer =
                                              $event.target.value
                                          }
                                        }
                                      })
                                    : _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-answer-result b-vspace-xs b-text-secondary"
                                        },
                                        [
                                          _c("div", [
                                            !_vm.loggedInProblem
                                              .answer_is_correct &&
                                            _vm.loggedInProblem.previous_guesses
                                              .length
                                              ? _c("p", [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.loggedInProblem
                                                          .previous_guesses[0]
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "answer" },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.loggedInProblem
                                                        .correct_answer
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          ])
                                        ]
                                      )
                                ],
                            _vm._v(" "),
                            !_vm.isCompleted && !_vm.submitting
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "solv-mcq-submit-button",
                                    class: [
                                      "btn btn-accent btn-submit",
                                      { disabled: !_vm.selectedAnswer }
                                    ],
                                    attrs: { type: "submit" }
                                  },
                                  [
                                    _vm._v(
                                      "\n              Submit\n            "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _vm.isAuthenticated &&
                        !_vm.submitting &&
                        !_vm.isCompleted
                          ? _c(
                              "div",
                              { staticClass: "solv-details-footer clearfix" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "solution-button-wrapper" },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn-solution btn-solution-full btn btn-flat active",
                                        on: { click: _vm.viewExplanation }
                                      },
                                      [
                                        _vm._v(
                                          "\n                View explanation\n              "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _vm.isCompleted
                        ? _c(
                            "div",
                            { staticClass: "dp-feedback-triggers row" },
                            [
                              _vm.solutionDiscussionState !== "solutions"
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "report-link",
                                      on: { click: _vm.viewExplanation }
                                    },
                                    [
                                      _vm._v(
                                        "\n            View explanation\n          "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.solutionDiscussionState !== "disputes"
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "report-link",
                                      on: { click: _vm.viewReports }
                                    },
                                    [
                                      _vm._v(
                                        "\n            View reports\n          "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                : _vm._e()
            ]
          : _vm._e(),
        _vm._v(" "),
        !_vm.isLocked && _vm.isCompleted
          ? _c(
              "div",
              {
                class: [
                  "endstate",
                  { "endstate-correct": _vm.loggedInProblem.answer_is_correct }
                ]
              },
              [
                _c("div", { staticClass: "endstate-texts" }, [
                  _c("h3", { staticClass: "endstate-title" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(this.endstate.title) +
                        "\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _vm.wasCompletedInThisSession && _vm.endstate.description
                    ? _c("p", { staticClass: "endstate-description" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.endstate.description) +
                            "\n        "
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _vm.wasCompletedInThisSession && _vm.endstate.xp !== undefined
                  ? _c("XPBadge", {
                      staticClass: "endstate-xp-badge dc-xp-badge",
                      attrs: {
                        xp: _vm.endstate.xp,
                        "show-plus-sign": "",
                        "has-earned": ""
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.submitting
          ? _c(
              "div",
              { staticClass: "submit-loader" },
              [
                _c(
                  "transition",
                  { attrs: { name: "fade-fast", mode: "out-in" } },
                  [
                    _c("LoadingAnimation", {
                      attrs: { color: "dark", size: "medium", type: "dots" }
                    })
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.isLocked
          ? [
              _c(
                "div",
                { class: ["dp-misc-posts", _vm.solutionDiscussionState] },
                [
                  _vm.isCompleted && _vm.solutionDiscussionState === "solutions"
                    ? _c(
                        "div",
                        { staticClass: "solv-explanation" },
                        [
                          _vm.problem.solution_brief &&
                          _vm.problem.solution_brief.length
                            ? _c("DailyChallengeSolutions", {
                                attrs: { solutions: _vm.problem.solution_brief }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm.isCompleted &&
                      _vm.solutionDiscussionState === "disputes"
                    ? _c(
                        "div",
                        { staticClass: "solv-disputes" },
                        [
                          _vm.problem.dispute_reports &&
                          _vm.problem.dispute_reports.length
                            ? _c("DailyChallengeDisputes", {
                                attrs: { disputes: _vm.problem.dispute_reports }
                              })
                            : _c(
                                "div",
                                {
                                  staticClass: "no-posts",
                                  attrs: { name: "dp-dispute-reports" }
                                },
                                [_c("p", [_vm._v("There are no reports yet.")])]
                              )
                        ],
                        1
                      )
                    : _vm._e()
                ]
              )
            ]
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", { staticClass: "title b-vspace-m" }, [
      _c("h1", [_vm._v("Today's Challenge")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }